"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  FETCH_PROFILE: 'FETCH_PROFILE',
  SHOW_PROFILE: 'SHOW_PROFILE',
  PROFILE_FETCHED: 'PROFILE_FETCHED',
  PROFILE_ERROR: 'PROFILE_ERROR',
  INITIALIZE_CARD: 'INITIALIZE_CARD',
  HIDE_PROFILE: 'HIDE_PROFILE',
  SET_MESSAGE_URL: 'SET_MESSAGE_URL'
};
exports.default = _default;